import { apiPost } from './apiClient';

const tryApiPost = async (paths, body, token) => {
  let lastError = null;
  for (const path of paths) {
    try {
      return await apiPost(path, body, token);
    } catch (error) {
      lastError = error;
      if (error?.status !== 404) {
        throw error;
      }
    }
  }
  throw lastError || new Error('Payment route not found');
};

export const createRazorpayOrder = ({ bookingId, amount, customerName, customerEmail, customerPhone, notes }, token) =>
  tryApiPost(
    [
      '/api/payments/razorpay/create-order',
      '/api/payments/razorpay/order',
    ],
    {
      bookingId,
      amount,
      customerName,
      customerEmail,
      customerPhone,
      notes,
    },
    token
  );

export const verifyRazorpayPayment = (
  { bookingId, paymentId, razorpay_order_id, razorpay_payment_id, razorpay_signature },
  token
) =>
  tryApiPost(
    [
      '/api/payments/razorpay/verify-payment',
      '/api/payments/razorpay/verify',
    ],
    {
      bookingId,
      paymentId,
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature,
    },
    token
  );

export const cancelRazorpayPayment = ({ bookingId, paymentId, orderId, razorpay_order_id, reason }, token) =>
  tryApiPost(
    [
      '/api/payments/razorpay/cancel-payment',
      '/api/payments/razorpay/cancel',
    ],
    {
      bookingId,
      paymentId,
      orderId,
      razorpay_order_id,
      reason,
    },
    token
  );
